function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { BUTTON_SUBMISSION, ERROR, OVERLAY, PO_JOB_NAMES, STASH } from '../constants.js';

// https://github.com/one-thd/ocm_pd_experience_customer-account-pojob-proallowance
export const poJob = () => {
  const trackEvent = event => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };
  const poJobEvents = {
    delete: () => {
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `${PO_JOB_NAMES}: meatball: delete`
        }
      };
      trackEvent(DDOEvent);
    },
    deleteOverlay: _ref => {
      let {
        output
      } = _ref;
      const {
        isMultiple
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: OVERLAY
        },
        eventInfo: {
          eventName: `delete po job name${isMultiple ? 's' : ''}`
        }
      };
      trackEvent(DDOEvent);
    },
    deleteSuccess: _ref2 => {
      let {
        output
      } = _ref2;
      const {
        count
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `${PO_JOB_NAMES}: deletion: ${count}`
        }
      };
      trackEvent(DDOEvent);
    },
    viewPurchases: () => {
      const DDOEvent = {
        category: {
          primaryCategory: STASH
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        eventMode: STASH,
        stash: {
          myAccount: {
            settings: `${PO_JOB_NAMES}: meatball: view purchases`
          }
        }
      };
      trackEvent(DDOEvent);
    },
    settingsToggle: _ref3 => {
      let {
        output
      } = _ref3;
      const {
        setting,
        value
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `${PO_JOB_NAMES}: checkout settings: ${String(setting).toLowerCase()}: ${String(value).toLowerCase()}`
        }
      };
      trackEvent(DDOEvent);
    },
    addOverlay: () => {
      const DDOEvent = {
        category: {
          primaryCategory: OVERLAY
        },
        eventInfo: {
          eventName: `add ${PO_JOB_NAMES}`
        }
      };
      trackEvent(DDOEvent);
    },
    addSuccess: _ref4 => {
      let {
        output
      } = _ref4;
      const {
        count
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `${PO_JOB_NAMES}: add: ${count}`
        }
      };
      trackEvent(DDOEvent);
    },
    multiselect: _ref5 => {
      let {
        output
      } = _ref5;
      const {
        action
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `po job names: multi: ${action}`
        }
      };
      trackEvent(DDOEvent);
    },
    search: _ref6 => {
      let {
        output
      } = _ref6;
      const {
        count
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `po job names: search: ${count}`,
          searchBy: 'po job names: search'
        }
      };
      trackEvent(DDOEvent);
    },
    sort: _ref7 => {
      let {
        output
      } = _ref7;
      const {
        sortedBy,
        sortDirection
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: 'po job names: sort',
          searchTerm: `${sortedBy} : ${sortDirection}`,
          searchBy: 'po job names: sort'
        }
      };
      trackEvent(DDOEvent);
    },
    tableViewRows: _ref8 => {
      let {
        output
      } = _ref8;
      const {
        target
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `po job names: view: ${target}`
        }
      };
      trackEvent(DDOEvent);
    },
    pagination: _ref9 => {
      let {
        output
      } = _ref9;
      const {
        rows,
        pageNumber
      } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `po job names: pagination: view ${rows} : page ${pageNumber}`
        }
      };
      trackEvent(DDOEvent);
    },
    postPageErrors: _ref10 => {
      let {
        output
      } = _ref10;
      const DDOEvent = {
        category: {
          primaryCategory: ERROR
        },
        eventInfo: {
          eventName: 'post page error',
          error: [_objectSpread({}, output)]
        }
      };
      trackEvent(DDOEvent);
    }
  };
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-delete', poJobEvents.delete);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-delete-overlay', poJobEvents.deleteOverlay);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-delete-success', poJobEvents.deleteSuccess);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-view-purchases', poJobEvents.viewPurchases);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-settings-toggle', poJobEvents.settingsToggle);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-add-overlay', poJobEvents.addOverlay);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-add-success', poJobEvents.addSuccess);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-multiselect', poJobEvents.multiselect);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-sort', poJobEvents.sort);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-table-view-rows', poJobEvents.tableViewRows);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-pagination', poJobEvents.pagination);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-post-page-error', poJobEvents.postPageErrors);
  window.LIFE_CYCLE_EVENT_BUS.on('po-job-search', poJobEvents.search);
};
//# sourceMappingURL=poJob.listener.analytics.js.map